import styled from "@emotion/styled";
import { COLOR_ERROR } from "../components/theme";
import { ParagraphHeaderSmall } from "../components/typography/Paragraph";

const ErrorMessage = styled(ParagraphHeaderSmall)<{
  color?: string;
  align?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  text-align: ${({ align }) => align ?? "center"};
  color: ${({ color }) => color ?? COLOR_ERROR};
  width: auto;
`;

export const PageErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 16px;
`;

export const FullPageErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PageError = styled(ErrorMessage)`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default ErrorMessage;
